<template>
  <div>
    <el-form :model="form" label-width="20px">
      <el-form-item v-if="showFromAcceptorSelector">
        <el-select
          v-model="fromAcceptorId"
          placeholder="请选择原受理人"
          style="width: 100%"
          :disabled="lockFromAcceptorSelect"
          :clearable="!lockFromAcceptorSelect"
        >
          <el-option
            v-for="item in acceptUsersList"
            :key="item.userId"
            :label="item.userName"
            :value="item.userId"
          ></el-option>
        </el-select>
      </el-form-item>
      <work-order-editor ref="workOrder"></work-order-editor>
      <el-form-item>
        <work-order-user-select
          ref="users"
          v-model="users"
          :multiple-limit="1"
          style="width: 100%"
          @input="handleInput"
        ></work-order-user-select>
      </el-form-item>
      <el-form-item>
        <el-checkbox v-model="isSuperAdmin" @change="handleChangeUser"
          >快速转给系统管理员</el-checkbox
        >
      </el-form-item>
      <div style="text-align: center">
        <el-button
          type="primary"
          size="small"
          :disabled="isClosed || isReject"
          @click="handleTransfer"
          >转接</el-button
        >
      </div>
    </el-form>
  </div>
</template>

<script>
import api from "plus/api";

export default {
  name: "workOrderTransfer",
  props: {
    workOrder: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      form: {
        recvId: "",
      },
      isSuperAdmin: false,
      users: [],
      fromAcceptorId: "",
    };
  },
  watch: {
    workOrder: {
      handler() {
        this.syncFromAcceptorDefault();
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    acceptUsersList() {
      const list = this.workOrder && this.workOrder.acceptUsers;
      return Array.isArray(list) ? list : [];
    },
    /** 多名受理人时需展示原受理人下拉 */
    showFromAcceptorSelector() {
      return this.acceptUsersList.length > 1;
    },
    /** 我的受理详情：多名受理人时锁定为当前登录人，不可切换 */
    lockFromAcceptorSelect() {
      return (
        this.showFromAcceptorSelector &&
        this.$route.name === "work.myAccept.detail"
      );
    },
    wkOrderId() {
      return this.$route.query.wkOrderId;
    },
    isClosed() {
      return this.workOrder && this.workOrder.status === 2;
    },
    isReject() {
      return this.workOrder && this.workOrder.status === 3;
    },
    userType() {
      const userType = new Map([
        ["work.myAccept.detail", "ACCEPTOR"],
        ["work.mySubmit.detail", "AUTHOR"],
        ["workmange.workQuality.detail", "MANAGER"],
        ["workmange.workOrderList.detail", "MANAGER"],
      ]);
      return userType.get(this.$route.name);
    },
  },
  methods: {
    syncFromAcceptorDefault() {
      const list = this.acceptUsersList;
      if (list.length === 0) {
        this.fromAcceptorId = "";
        return;
      }
      if (list.length === 1) {
        this.fromAcceptorId = list[0].userId;
        return;
      }
      if (this.$route.name === "work.myAccept.detail") {
        const uid =
          this.$store.state.userInfo && this.$store.state.userInfo.userId;
        const hit = list.find((a) => a.userId === uid);
        this.fromAcceptorId = hit ? hit.userId : list[0].userId;
        return;
      }
      this.fromAcceptorId = "";
    },
    handleInput(val) {
      if (val.length) {
        this.form.recvId = val[0].userId;
      } else {
        this.form.recvId = "";
      }
    },
    handleChangeUser(val) {
      if (val) {
        this.users = [{ userName: "禹杨", userId: "yuyang@meb.com" }];
        this.form.recvId = "yuyang@meb.com";
        this.$refs.users.initUserOptions();
      } else {
        this.users = [];
        this.form.recvId = "";
      }
    },
    async handleTransfer() {
      const editorData = this.$refs.workOrder.getData();
      const params = {
        ...editorData,
        ...this.form,
        wkOrderId: this.wkOrderId,
        optUserType: this.userType,
      };
      if (!params.remark) {
        return this.$message.error("请输入转接申请内容！");
      }
      if (!params.recvId) {
        return this.$message.error("请选择需要转接的人员");
      }
      if (
        this.acceptUsersList.length > 1 &&
        this.$route.name !== "work.myAccept.detail" &&
        !this.fromAcceptorId
      ) {
        return this.$message.error("请选择原受理人");
      }
      if (this.fromAcceptorId) {
        params.fromAcceptorId = this.fromAcceptorId;
      }
      const response = await api.workmanage.wktransfer(params);
      if (response.data.success) {
        this.$message.success("转接成功！");
        this.$refs.workOrder.clearData();
        this.form.recvId = "";
        this.users = [];
        this.$emit("change");
      } else {
        this.$message.error("转接失败！");
      }
    },
    handleReject() {
      this.$confirm("注意！该工单将会驳回给提问人，请慎重!", "驳回工单", {
        confirmButtonText: "确认",
        confirmButtonClass: "confirmBtn",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      }).then(async () => {
        const editorData = this.$refs.workOrder.getData();
        const tempPara = {
          attachments: editorData.attachments,
          remark: editorData.remark,
          status: 3,
          workOrderId: this.wkOrderId,
        };
        api.work
          .dealWorkOrderById(tempPara)
          .then((res) => {
            if (res.data.success) {
              this.$message.success("操作成功！");
              this.$emit("change");
            }
          })
          .catch((err) => {});
      });
    },
  },
};
</script>

<style scoped>
.transfer-editor-form-item {
  margin-bottom: 12px;
}
.transfer-editor-form-item /deep/ .el-form-item__content {
  margin-left: 0 !important;
}
</style>
